import '../worker/worker.js';

// all worker code will be included here and available to the main thread
// so that ogc-client can work without a worker
